<template lang="html">
  <div>
    <div v-if="termos.length > 0 && !aceito">
      <termo-aceite-login
          :termos="termos"
          :title="implantacao.nome"
          @ACEITO="termoAceito">
      </termo-aceite-login>
    </div>
    <div v-if="aplicacaoLiberada">
      <sidebar
        ref="sidenav"
        :abrir="abrirMenu"
        :logo="implantacao.logomarca"
        :menuList="filteredMenuList"></sidebar>

      <toolbar class="Home__PageTeller"
        :title="implantacao.nome"
        :hideMenu="hideMenu"
        :usuario="usuario"
        :perfil="usuarioLogado.perfil"
        :estruturaUsuario="usuarioLogado.estrutura_usuario"
        :mail="usuarioLogado.email"
        :possui-alerta-manutencao="possuiAlertaManutencao"
        :texto-alerta-manutencao="alertaManutencao.textoAlertaManutencao"
        :ind-alerta-comunicacao="indAlertaComunicacao"
        :ind-alerta-manutencao="indAlertaManutencao"
        :link="alertaManutencao.link ? alertaManutencao.link : ''"
        scroll-target="#content"
        @salvaUsuarioAcessoAlerta="salvaUsuarioAcessoAlerta"
        @TOGGLE_SIDEBAR="toggleSidenav"
        @RESET_SIDEBAR="resetSidebar"
        @Toolbar_selecionarTenant="setTenantERecarrega"></toolbar>

      <v-main id="content">
        <v-container
          class="fill-height"
          fluid>
          <v-row style="padding-bottom: 1em" v-if="dicionarioCarregado">
            <v-col cols="12">
              <transition name="slide-fade"
                          mode="out-in" v-if="dicionarioCarregado">
                <router-view></router-view>
              </transition>
            </v-col>
          </v-row>
        </v-container>
      </v-main>
    </div>

    <div id="spinner-loading">
      <div>
        <v-container fluid>
          <v-row align="center" justify="center">
            <v-progress-circular
              indeterminate
              :size="100"
              :width="3"
              color="primary"
            />
          </v-row>
        </v-container>
      </div>
    </div>

    <confirm ref="modalSessao"
      :persistent="true"
      :message="$t('errors.sessao_expirada')"
      :title="$t('title.sessao_expirada')"
      :agree-label="$t('label.ok')"
      hide-disagree
      @agree="logoutAceito()"
      />

    <confirm ref="modalErroInicializacaoAplicacao"
      :persistent="true"
      :message="mensagemModalInicializacao"
      :title="$tc('title.aviso', 1)"
      :agree-label="$t('label.ok')"
      :disagree-label="$t('label.recarregar')"
      :hide-disagree="esconderBotaoRecarregar"
      @disagree="recarregarAplicacao()"
      @agree="fecharModalErro()"
      />

    <generic-dialog ref="modalRedirecionamentoURL"
      :persistent="true"
      :message="mensagemModalRedirecionamentoURL"
      :title="$tc('title.aviso', 1)"
      hide-agree
      hide-disagree
      />

    <tenant-dialog
      ref="tenantDialog"
      @TenantDialog_selecionarTenant="setStorageTenant"
    />

    <mensagem-aviso-login-dialog
      ref="MensagemAvisoLoginDialog"
      :tenant-id="tenantIdSelecionado"
      @agree="verificaSeContinuaInicializacao()"
    />

    <snackbar></snackbar>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import Sidebar from '@/shared-components/sidebar/Sidebar';
import Toolbar from '@/shared-components/toolbar/Toolbar';
import Snackbar from '@/shared-components/snackbar/Snackbar';
import TenantDialog from '@/shared-components/tenant/TenantDialog';
import dicionario from '@/common/functions/dicionario';
import menuList from '@/menu/menu';
import { copyObject } from '@/common/functions/helpers';
import resourceImportacao from '@/common/resources/importacoes';
import resourceDicionario from '@/common/resources/dicionario';
import resourceUsuario from '@/common/resources/usuario';
import resourceControladorTrade from '@/common/resources/controlador-trade';
import { showInitialLoading, hideInitialLoading } from '@/common/functions/loading';
import resourceTermoAceite from '@/common/resources/termo-aceite';
import { interpolarDicionario } from '@/config/i18n';
import { authKeycloak } from '@/config/authKeycloak';
import { authIDMagalu } from '@/config/authIdMagalu';
import Confirm from '@/shared-components/dialog/Confirm';
import GenericDialog from '@/shared-components/dialog/GenericDialog';
import MensagemAvisoLoginDialog from '@/shared-components/dialog/MensagemAvisoLoginDialog';
import TermoAceiteLogin from './termo-aceite/TermoAceiteLogin';

export default {
  name: 'Home',
  data() {
    return {
      importacaoResources: resourceImportacao(this.$resource),
      dicionarioResources: resourceDicionario(this.$resource),
      usuarioResources: resourceUsuario(this.$resource),
      controladorResources: resourceControladorTrade(this.$resource),
      termoAceiteResources: resourceTermoAceite(this.$resource),
      alertaManutencaoResources: this.$api.alertaManutencao(this.$resource),
      roleResources: this.$api.role(this.$resource),
      jobConfigResources: this.$api.jobConfiguracao(this.$resource),
      apuracaoConfigResources: this.$api.apuracaoConfiguracao(this.$resource),
      planejamentoAcaoConfigResources: this.$api.planejamentoAcaoConfiguracao(this.$resource),
      liquidacaoConfigResources: this.$api.liquidacaoConfiguracao(this.$resource),
      workflowConfigResources: this.$api.workflowConfiguracao(this.$resource),
      configSistemaResource: this.$api.configuracaoSistema(this.$resource),
      aplicacaoLiberada: false,
      dicionarioCarregado: false,
      eventLoop: null,
      eventLoopTimer: 10E3,
      mensagemModalInicializacao: '',
      mensagemModalRedirecionamentoURL: '',
      menuList: [],
      usuarioInfo: {},
      sombraToolbar: false,
      abrirMenu: false,
      recarregar: false,
      termos: [],
      aceito: false,
      possuiAlertaManutencao: false,
      alertaManutencao: {},
      indAlertaComunicacao: false,
      indAlertaManutencao: false,
      indTenantSelecionado: false,
      tenantIdSelecionado: '',
      esconderBotaoRecarregar: false,
      indHabilitaMensagemAvisoLogin: false,
      indForcarLogout: false,
      indValidacaoMfaHabilitada: false,
      aplicacaoMontada: false,
      indProcessoMfaValidado: false,
      usuarioLogouSemTenantSelecionado: false,
    };
  },
  components: {
    TenantDialog,
    Snackbar,
    Sidebar,
    Toolbar,
    TermoAceiteLogin,
    Confirm,
    GenericDialog,
    MensagemAvisoLoginDialog,
  },
  computed: {
    ...mapGetters('roles', [
      'getAllRoles',
      'getUsuario',
      'getTenantId',
      'getTenantIds',
      'getTipoAuth',
    ]),
    ...mapGetters('usuario', [
      'usuarioLogado',
    ]),
    ...mapGetters('implantacao', [
      'implantacao',
      'chaveEmpresa',
      'indAmbienteProdutivo',
    ]),
    ...mapGetters('parametros', [
      'parametros',
    ]),
    canAccessPageList() {
      if (!this.getAllRoles) {
        return [];
      }
      return this.getAllRoles
        .filter((el) => el.indexOf('_PAGINA') !== -1 || el.indexOf('_CRUD') !== -1);
    },
    canImport() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles
        .filter((el) => el.endsWith('_IMPORTAR') || el.endsWith('_CRUD')).length;
    },
    filteredMenuList() {
      if (!this.getAllRoles || !this.getAllRoles.length) {
        return [];
      }
      const filter = [];
      const routesFiltradas = [];
      this.menuList
        .forEach((m) => {
          if (m.sub) {
            const subFiltrado = this.filtrarSubMenu(m.sub);
            if (subFiltrado.length) {
              m.sub = subFiltrado;
              filter.push(m);
            }
          } else {
            this.getAllRoles.forEach((r) => {
              if (this.validarRotaPorRole(m, routesFiltradas, r) && this.validarTenants(m)) {
                filter.push(m);
                routesFiltradas.push(m.route);
              }
            });
          }
        });
      return filter;
    },
    hideMenu() {
      return !this.filteredMenuList.length;
    },
    pageName() {
      return this.$route.name;
    },
    usuario() {
      return this.getUsuario && this.getUsuario.length ? this.getUsuario : this.usuarioLogado.nome;
    },
    state() {
      return this.$route.name;
    },
    path() {
      return this.$route.path;
    },
  },
  methods: {
    ...mapActions('importacao', [
      'popularImportacoesAndamento',
      'popularTiposImportacao',
    ]),
    ...mapActions('roles', [
      'setTenantId',
      'carregarTenantIds',
      'settarTodasRoles',
    ]),
    ...mapActions('usuario', [
      'carregarInformacoesUsuario',
    ]),
    ...mapActions('controlador', [
      'carregarControladores',
    ]),
    ...mapActions('implantacao', [
      'carregarImplantacao',
    ]),
    filtrarSubMenu(subMenu) {
      const filter = [];
      const routesFiltradas = [];
      subMenu.forEach((m) => {
        if (m.submenu) {
          const subFilter = this.filtrarSubMenu(m.sub);
          if (subFilter.length > 0) {
            filter.push({
              ...m,
              sub: subFilter,
            });
          }
        } else {
          this.getAllRoles.forEach((r) => {
            if (this.validarRotaPorRole(m, routesFiltradas, r) && this.validarTenants(m)) {
              filter.push(m);
              routesFiltradas.push(m.route);
            }
          });
        }
      });
      return filter;
    },
    validarRotaPorRole(menu, routesFiltradas, role) {
      return ((Array.isArray(menu.role) && menu.role.includes(role)) || role.startsWith(menu.role))
        && !routesFiltradas.includes(menu.route);
    },
    validarTenants(menu) {
      return Array.isArray(menu.tenants) && menu.tenants.includes(this.chaveEmpresa);
    },
    buscarImportacoesAndamento() {
      if (this.canImport) {
        this.popularImportacoesAndamento(this.importacaoResources.listarAndamento)
          .then(() => {
            this.resetEventLoop(10E3);
          });
      }
    },
    buscarTiposImportacao() {
      if (this.canImport) {
        this.popularTiposImportacao({
          resource: this.importacaoResources.listarTipos,
          roles: this.getAllRoles,
        });
      }
    },
    resetEventLoop(timer) {
      if (this.eventLoopTimer === timer) {
        return;
      }
      window.clearInterval(this.eventLoop);
      this.eventLoopTimer = timer;
      this.eventLoopImportacoes();
    },
    eventLoopImportacoes() {
      if (!this.eventLoop && this.canImport) {
        this.eventLoop = setInterval(() => {
          this.buscarImportacoesAndamento();
        }, this.eventLoopTimer);
      }
    },
    toggleSidenav() {
      this.abrirMenu = !this.abrirMenu;
    },
    resetSidebar() {
      this.irParaInicio();
      this.$refs.sidenav.resetSidebar();
    },
    irParaInicio() {
      if (this.$router.currentRoute
        && !this.$router.currentRoute.path.includes('dashboard-inicial')) {
        this.$router.push({ name: 'inicio' });
      }
    },
    logoutAceito() {
      this.$refs.modalSessao.close();
      sessionStorage.removeItem('redirecionado');
      if (this.getTipoAuth === 'idMagalu') {
        authIDMagalu.removerDadosIdMagalu();
        authIDMagalu.doLogout();
      } else {
        authKeycloak.doLogout();
      }
    },
    iniciaAplicacao() {
      this.aplicacaoLiberada = true;
      this.dicionarioCarregado = true;
      this.buscarImportacoesAndamento();
      this.buscarTiposImportacao();
    },
    recarregarAplicacao() {
      window.location.reload();
    },
    fecharModalErro() {
      this.$refs.modalErroInicializacaoAplicacao.close();
      setTimeout(() => {
        this.esconderBotaoRecarregar = false;
      }, 3000);
      sessionStorage.clear();
      localStorage.removeItem('xTenantId');
      if (this.getTipoAuth === 'idMagalu') {
        authIDMagalu.removerDadosIdMagalu();
        authIDMagalu.doLogout();
      } else {
        authKeycloak.doLogout();
      }
    },
    carregarTermos() {
      return this.termoAceiteResources.buscarTermosLogin()
        .then((response) => {
          this.termos = response.data;
        });
    },
    termoAceito() {
      this.aceito = true;
      this.iniciaAplicacao();
      setTimeout(() => this.$vuetify.goTo(0), 3000);
      setTimeout(() => hideInitialLoading(), 3000);
    },
    carregarInformacoes() {
      showInitialLoading();
      Promise.all([
        this.carregarControladores(this.controladorResources.listar),
        this.carregarImplantacao(this.dicionarioResources.implantacao),
      ])
        .then(() => this.carregarTermos())
        .then(() => {
          if (this.termos.length === 0) {
            this.iniciaAplicacao();
            setTimeout(() => hideInitialLoading(), 3000);
          }
        })
        .catch((e) => {
          if (e.status === 403) {
            this.mensagemModalInicializacao = this.$t('errors.inicializacao_sem_perfil_ou_divisao');
          } else {
            this.mensagemModalInicializacao = this.$t('errors.inicializacao');
          }
          this.abrirModalErroInicializacao();
          window.setTimeout(() => { throw e; });
        });
    },
    abrirModalErroInicializacao() {
      this.$refs.modalErroInicializacaoAplicacao.open();
      setTimeout(() => hideInitialLoading());
    },
    executarPosDicionario() {
      this.verificarRedirecionamento();
    },
    executarCarregamentoDeInformacoes() {
      this.carregarInformacoes();
      this.buscarAlertasManutencao();
    },
    buscarAlertasManutencao() {
      const params = {
        data_atual: this.moment().format('DD-MM-YYYY HH:mm'),
      };
      this.alertaManutencaoResources.listarAlertasParaExibir(params).then((response) => {
        this.possuiAlertaManutencao = response.data != null && response.data.id != null && response.data.id > 0;
        if (this.possuiAlertaManutencao) {
          this.alertaManutencao = response.data;

          if (this.alertaManutencao.tipoAlerta === 'COMUNICACAO') {
            const idsPerfil = this.alertaManutencao.idsPerfil.split(',').map((valor) => parseInt(valor, 10));
            const idPerfilUsuarioLogado = this.usuarioLogado.idPerfil;
            if (idsPerfil.includes(idPerfilUsuarioLogado)) {
              this.indAlertaComunicacao = true;
              this.indAlertaManutencao = false;
            }

            if (this.alertaManutencao.dataInicio === this.alertaManutencao.dataFim) {
              this.alertaManutencao.textoAlertaManutencao = this.$t('message.alerta_manutencao_inicio_fim_mesmo_dia_comunicacao', this.alertaManutencao);
            } else {
              this.alertaManutencao.textoAlertaManutencao = this.$t('message.alerta_manutencao_inicio_fim_dias_diferentes_comunicacao', this.alertaManutencao);
            }
          } else {
            this.indAlertaComunicacao = false;
            this.indAlertaManutencao = true;

            if (this.alertaManutencao.dataInicio === this.alertaManutencao.dataFim) {
              this.alertaManutencao.textoAlertaManutencao = this.$t('message.alerta_manutencao_inicio_fim_mesmo_dia', this.alertaManutencao);
            } else {
              this.alertaManutencao.textoAlertaManutencao = this.$t('message.alerta_manutencao_inicio_fim_dias_diferentes', this.alertaManutencao);
            }
          }
        }
      }, (err) => {
        this.$error(this, err);
      });
    },
    salvaUsuarioAcessoAlerta() {
      const params = {
        id_usuario: this.usuarioLogado.id,
        id_alerta: this.alertaManutencao.id,
      };

      this.alertaManutencaoResources.salvaUsuarioLogAlertaManutencao(params).then(() => {})
        .catch((err) => {
          this.$toast(err.data.error);
        });
    },
    carregarTenantsAplicacao() {
      this.indTenantSelecionado = false;
      const tenantDaSession = sessionStorage.getItem('xTenantId') || localStorage.getItem('xTenantId');
      if (!tenantDaSession) {
        this.usuarioLogouSemTenantSelecionado = true;
        this.setStorageTenant('magalu', true);
      } else if (!this.usuarioLogouSemTenantSelecionado) {
        this.setStorageTenant(tenantDaSession);
      }

      const roles = ['TRADE', 'TRADELINKS_SISTEMA'];
      this.settarTodasRoles(roles);

      if ((this.getTipoAuth === 'idMagalu' && this.indProcessoMfaValidado) || this.getTipoAuth !== 'idMagalu') {
        Promise.all([
          this.carregarTenantIds(this.usuarioResources.buscarTenantsUsuarioLogado),
        ])
          .then(() => this.selecionarTenant())
          .catch((err) => {
            if (err.status === 404) {
              this.indTenantSelecionado = false;
              this.esconderBotaoRecarregar = true;

              let erros = [];
              if (err?.data?.erros && Array.isArray(err.data.erros)) {
                erros = err.data.erros;
              } else if (err?.bodyText) {
                try {
                  const parsed = JSON.parse(err.bodyText);
                  if (parsed.erros && Array.isArray(parsed.erros)) {
                    erros = parsed.erros;
                  }
                } catch (parseErr) {
                  const bodyStr = String(err.bodyText || '');
                  if (bodyStr.includes('omni.usuario.not_found')) {
                    erros = ['omni.usuario.not_found'];
                  } else if (bodyStr.includes('omni.usuario.not_active')) {
                    erros = ['omni.usuario.not_active'];
                  }
                }
              }

              if (erros.includes('omni.usuario.not_found')) {
                this.mensagemModalInicializacao = this.$t('errors.inicializacao_usuario_login_nao_encontrado');
              } else if (erros.includes('omni.usuario.not_active')) {
                this.mensagemModalInicializacao = this.$t('errors.usuario_inativo');
              } else {
                this.mensagemModalInicializacao = this.$t('errors.inicializacao_sem_tenant_ativo');
              }

              this.abrirModalErroInicializacao();
            } else {
              this.$toast(err.data.error);
              this.fecharModalErro();
            }
            window.setTimeout(() => { throw err; });
          });
      }
    },
    setStorageTenant(tenantId, isTenantPadrao = false) {
      this.tenantIdSelecionado = tenantId;
      this.setTenantId(tenantId);
      this.setTenantColor(tenantId);
      sessionStorage.setItem('xTenantId', tenantId);
      if (!isTenantPadrao) {
        localStorage.setItem('xTenantId', tenantId);
      }

      if (this.indTenantSelecionado) {
        this.carregarRolesPerfilUsuarioLogado();
      }
    },
    carregarRolesPerfilUsuarioLogado() {
      this.roleResources.listarRolesPerfilLogado()
        .then((response) => {
          const roles = response.data || [];
          this.settarTodasRoles(roles);
          this.baixarDicionario();
        })
        .catch((e) => {
          window.setTimeout(() => { throw e; });
        });
    },
    limparMetadados() {
      const state = { ...this.$store.state };
      const currentState = copyObject(state);
      const currentMetadados = copyObject(state.metadados);
      // percorre o metadados atual e limpa os valores carregados anteriormente em outro tenant
      Object.keys(currentMetadados).forEach((key) => {
        if (currentMetadados[key] !== null) {
          currentMetadados[key] = null;
        }
      });
      // atualiza a nova state
      const newState = Object.assign(currentState, {
        metadados: currentMetadados,
      });

      // carrega a nova state
      this.$store.replaceState(newState);
    },
    baixarDicionario() {
      dicionario.carregar()
        .then((resDicionario) => {
          this.$i18n.setLocaleMessage('pt-br', interpolarDicionario(resDicionario).messages['pt-br']);
          this.menuList = menuList(this);
          setTimeout(() => this.executarPosDicionario(), 2E2);
        }).catch((e) => {
          if (e.status && e.message && e.status === 403) {
            window.alert(e.message); // eslint-disable-line
          }
          if (e.status && e.message && e.status === 401) {
            if (this.getTipoAuth === 'idMagalu') {
              authIDMagalu.notifySessionExpired();
            } else {
              authKeycloak.notifySessionExpired();
            }
          }
        });
    },
    setTenantERecarrega(tenantId) {
      this.setStorageTenant(tenantId);
      sessionStorage.removeItem('redirecionado');
      this.irParaInicio();
      this.limparMetadados();
      this.aplicacaoLiberada = false;
    },
    setTenantColor(tenantId) {
      switch (tenantId) {
        case 'epoca':
          this.$vuetify.theme.themes.light.primary = '#F05A8C';
          break;
        case 'kabum':
          this.$vuetify.theme.themes.light.primary = '#FF6500';
          break;
        default:
          this.$vuetify.theme.themes.light.primary = '#0086ff';
      }
    },
    selecionarTenant() {
      if (this.getTenantIds.length === 1) {
        this.indTenantSelecionado = true;
        this.setStorageTenant(this.getTenantIds[0]);
      } else if (this.getTenantIds.length > 1) {
        const selectedTenantSession = sessionStorage.getItem('xTenantId');
        const selectedTenantLocal = localStorage.getItem('xTenantId');
        this.indTenantSelecionado = true;
        if (selectedTenantSession && this.getTenantIds.includes(selectedTenantSession)
          && this.$route.query.tenant && selectedTenantSession === this.$route.query.tenant) {
          this.setStorageTenant(selectedTenantSession);
        } else if (this.$route.query.tenant) {
          this.setStorageTenant(this.$route.query.tenant);
        } else if (selectedTenantLocal && this.getTenantIds.includes(selectedTenantLocal)) {
          this.setStorageTenant(selectedTenantLocal);
        } else {
          this.setTenantId('');
          this.$refs.tenantDialog.open();
          hideInitialLoading();
        }
      } else {
        this.indTenantSelecionado = false;
        this.mensagemModalInicializacao = this.$t('errors.usuario_inativo');
        this.esconderBotaoRecarregar = true;
        this.abrirModalErroInicializacao();
      }
    },
    verificarRedirecionamento() {
      this.carregarInformacoesUsuario(this.usuarioResources.informacao)
        .then(() => {
          this.verificarMensagemAvisoLogin();
        }).catch(() => {
          hideInitialLoading();
        });
    },
    verificarMensagemAvisoLogin() {
      if (this.indValidacaoMfaHabilitada) {
        this.continuarInicializacao();
        return;
      }
      const userId = this.usuarioLogado.id;
      const tenantId = this.getTenantId;
      const localStorageKey = `modalAvisoLogin_${userId}_${tenantId}`;

      const hoje = new Date().toISOString().split('T')[0];
      const dataSalva = localStorage.getItem(localStorageKey);
      if (dataSalva === hoje) {
        this.continuarInicializacao();
        return;
      }
      const tipoUsuario = this.usuarioLogado.tipo;
      this.usuarioResources.buscaDadosMensagemAvisoLogin(({ tipoUsuario }))
        .then((res) => {
          const { indHabilitaMensagemAvisoLogin, mensagem } = res.body;
          if (indHabilitaMensagemAvisoLogin) {
            this.$refs.MensagemAvisoLoginDialog.open(mensagem);
            localStorage.setItem(localStorageKey, hoje);
          } else {
            this.continuarInicializacao();
          }
        }).catch(() => {
          this.continuarInicializacao();
        });
    },
    verificaSeContinuaInicializacao() {
      if (this.indForcarLogout) {
        this.indForcarLogout = false;
        this.logoutAceito();
      } else {
        this.continuarInicializacao();
      }
    },
    continuarInicializacao() {
      if (this.usuarioLogado && !this.usuarioLogado.indPerfilUsuarioExterno) {
        const urlAtual = window.location.href;
        const { urlAdmProd, urlExternaProd } = this.usuarioLogado;

        if (urlAtual.includes(urlExternaProd)) {
          hideInitialLoading();
          this.mensagemModalRedirecionamentoURL = this.$t('message.acesso_via_vpn', { params: urlAdmProd });
          this.$refs.modalRedirecionamentoURL.open();
        } else {
          setTimeout(() => this.executarCarregamentoDeInformacoes(), 2E2);
        }
      } else {
        setTimeout(() => this.executarCarregamentoDeInformacoes(), 2E2);
      }
    },
    validarMfa() {
      this.usuarioResources.validarMfa()
        .then((response) => {
          const dados = response.data;
          this.indProcessoMfaValidado = true;
          if (dados && dados.indValidacaoMfaHabilitada) {
            if (dados.mfaValido) {
              this.indValidacaoMfaHabilitada = dados.indValidacaoMfaHabilitada;
              setTimeout(() => this.carregarTenantsAplicacao(), 2E2);
            } else {
              this.indForcarLogout = true;
              this.$refs.MensagemAvisoLoginDialog.open(dados.mensagem);
            }
          } else {
            setTimeout(() => this.carregarTenantsAplicacao(), 2E2);
          }
        });
    },
  },
  mounted() {
    setTimeout(() => this.carregarTenantsAplicacao(), 2E2);
  },
  beforeUpdate() {
    if (this.aplicacaoMontada === false) {
      this.aplicacaoMontada = true;

      if (this.getTipoAuth === 'idMagalu') {
        this.validarMfa();
        authIDMagalu.registerSessionListener({
          onSessionExpired: this.$refs.modalSessao.open,
        });
      } else {
        authKeycloak.registerSessionListener({
          onSessionExpired: this.$refs.modalSessao.open,
        });
      }
    }
  },
  beforeDestroy() {
    window.clearInterval(this.eventLoop);
  },
};
</script>
<style lang="scss">

.HOME__logo_div {
  width: 120px;
  height: 120px;
  padding: 35px;
  position: absolute;
}

.HOME__logo svg path {
  fill: var(--v-primary-base);
}

#spinner-loading > div {
  align-items: center;
  display: flex;
  height: 100%;
  width: 100%;
  justify-content: center;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  background-color: #eae9e9;
  opacity: .7;
}
</style>
